module.exports = __webpack_public_path__ + "static/media/edit-red.f0f298cc.svg";